<ssg-multi-select
  [multiple]="true"
  [items]="dynamicItems"
  [placeholder]="placeholder"
  [disabled]="disabled"

  (blur)="onBlur($event)"
  (add)="onAdd($event)"
  (remove)="onRemove($event)"
  >
</ssg-multi-select>